import { createActions } from 'redux-actions';
import { GetAllInsurancePolicyParams } from '@apis/InsurancePolicyApi';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { Pagination } from '@models/Pagination';

export type State = {
  policies?: InsurancePolicy[] | null;
  pagination?: Pagination;
  isLoading?: boolean;
}

export type InsurancePoliciesFetchPayload = GetAllInsurancePolicyParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePoliciesFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICIES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_POLICY_LIST_PAGE',
  },
);
